import { useForm as useFormHook } from "hooks";
import {
    FormField,
    type OnboardingPaymentMethods,
    type OnboardingPaymentMethodsForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = (
    { methods = [] }: Partial<OnboardingPaymentMethods>
): OnboardingPaymentMethods => ({
    [FormField.Methods]: methods
});

export const useForm = (onboardingPaymentMethods: OnboardingPaymentMethodsForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingPaymentMethods,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
